import { render, staticRenderFns } from "./CriterionRating.vue?vue&type=template&id=0fb40356&scoped=true&"
import script from "./CriterionRating.vue?vue&type=script&lang=js&"
export * from "./CriterionRating.vue?vue&type=script&lang=js&"
import style0 from "./CriterionRating.vue?vue&type=style&index=0&id=0fb40356&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb40356",
  null
  
)

export default component.exports